import { TextInput, useTranslate } from 'react-admin';
import { useWatch } from 'react-hook-form';
import { buildParameterName } from '@/constants/ParameterValueTypes.js';

export const ParameterComputedInput = () => {
    const translate = useTranslate();
    const systemName = useWatch({ name: 'systemName' });
    const type = useWatch({ name: 'type' });

    return (
        <TextInput
            source='parameter'
            label={translate('resources.parameter.fields.parameter')}
            format={() => buildParameterName(systemName, type)}
            readOnly
            fullWidth
        />
    );
};
